<template>
    <div class="section mt-1 meetings-tabs-wrap" v-if="!tabHome && !tabAssignments">
        <ul class="nav nav-tabs capsuled meetings-tabs" role="tablist">
            <li class="nav-item">
                <a class="nav-link" :class="{ active: tabUpcoming }" data-bs-toggle="tab" href="javascript:void(0)" role="tab"
                    @click="goToTab('Upcoming')">
                    <ion-icon name="list-outline" role="img" class="md hydrated" aria-label="list-outline"></ion-icon>
                    Upcoming
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :class="{ active: tabOld }" data-bs-toggle="tab" href="javascript:void(0)" role="tab"
                    @click="goToTab('Old')">
                    <ion-icon name="timer-outline" role="img" class="md hydrated" aria-label="timer-outline"></ion-icon>
                    Old
                </a>
            </li>
        </ul>
    </div>
    <div class="section mt-1">
        <div class="section text-center mt-1" v-if="loading">
            <div class="spinner-border text-secondary" role="status"></div>
        </div>
        <div class="listed-detail mt-3" v-if="responseData.list.length == 0 && !loading && (tabUpcoming || tabOld)">
            <h3 class="text-center mt-2 text-primary">No Data Available
            </h3>
        </div>

        <!-- Home: quick actions only -->
        <div class="goals" v-if="tabHome && !loading">
            <div class="meeting-actions-grid">
                <div class="action-card-link" v-if="user_level <= 3">
                    <div class="action-card create-gradient" @click="openCreateMeetingModal">
                        <div class="action-card-content">
                            <div class="action-card-icon-wrapper">
                                <ion-icon name="add-outline"></ion-icon>
                            </div>
                            <div class="action-card-text">
                                <span class="action-card-title">Create Meeting</span>
                            </div>
                        </div>
                    </div>
                </div>
                <router-link :to="'/org/'+user_level+'/'+user_level_id+'/meeting-report'" v-if="user_level <= 3" class="action-card-link">
                    <div class="action-card report-gradient">
                        <div class="action-card-content">
                            <div class="action-card-icon-wrapper">
                                <ion-icon name="bar-chart-outline"></ion-icon>
                            </div>
                            <div class="action-card-text">
                                <span class="action-card-title">Meeting Report</span>
                            </div>
                        </div>
                    </div>
                </router-link>
                <div class="action-card-link">
                    <div class="action-card meetings-gradient" @click="goToTab('Upcoming')">
                        <div class="action-card-content">
                            <div class="action-card-icon-wrapper">
                                <ion-icon name="calendar-outline"></ion-icon>
                            </div>
                            <div class="action-card-text">
                                <span class="action-card-title">My Meetings</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="action-card-link">
                    <div class="action-card assignments-gradient" @click="goToTab('Assignments')">
                        <div class="action-card-content">
                            <div class="action-card-icon-wrapper">
                                <ion-icon name="checkmark-done-outline"></ion-icon>
                            </div>
                            <div class="action-card-text">
                                <span class="action-card-title">My Assignments</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Today's Meetings List -->
            <div v-if="todayMeetings && todayMeetings.length > 0" class="today-meetings-section">
                <h3 class="section-title">Today's Meetings</h3>
                <div class="meeting-grid">
                    <div class="meeting-card" v-for="todayMeeting in todayMeetings" v-bind:key="todayMeeting.id">
                        <router-link :to="'meeting/' + todayMeeting.meeting_id" class="meeting-link">
                            <div class="in">
                                <div class="meeting-header-compact">
                                    <h3 class="meeting-title-compact">{{ todayMeeting.meeting.meeting_name_mal && todayMeeting.meeting.meeting_name_mal !== 'N' ? todayMeeting.meeting.meeting_name_mal : todayMeeting.meeting.meeting_name }}</h3>
                                    <span class="status-badge price mal-text">
                                        <ion-icon name="checkmark-circle-outline" class="price-icon" title="Conducted"></ion-icon>
                                    </span>
                                </div>
                                <div class="meeting-info-compact">
                                    <span class="info-item">
                                        <ion-icon name="calendar-outline"></ion-icon>
                                        {{ todayMeeting.meeting.meeting_date ? todayMeeting.meeting.meeting_date : '--/--/----' }}
                                    </span>
                                    <span class="info-separator">/</span>
                                    <span class="info-item">
                                        <ion-icon name="time-outline"></ion-icon>
                                        {{ todayMeeting.meeting.meeting_time ? todayMeeting.meeting.meeting_time : '--:--' }}
                                    </span>
                                    <span class="info-separator">/</span>
                                    <span class="info-item">
                                        <ion-icon name="people-outline"></ion-icon>
                                        {{ todayMeeting.participants_count ? todayMeeting.participants_count : '---' }}
                                    </span>
                                </div>
                                <div class="meeting-location-compact">
                                    <ion-icon name="location-outline"></ion-icon>
                                    <span>{{ todayMeeting.meeting.meeting_location ? todayMeeting.meeting.meeting_location : '---' }}</span>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div v-else-if="!loading && todayMeetings && todayMeetings.length === 0" class="no-meetings-message">
                <p class="text-muted text-center">'No meetings scheduled for today'</p>
            </div>
        </div>

        <!-- Upcomings -->
        <div class="goals" v-if="tabUpcoming && !loading">
            <!-- item -->
            <div class="meeting-grid">
                <div class="meeting-card" v-for="upcomingMeeting in responseData.list" v-bind:key="upcomingMeeting.id">
                    <router-link :to="'meeting/' + upcomingMeeting.meeting_id" class="meeting-link">
                        <div class="in">
                            <div class="meeting-header-compact">
                                <h3 class="meeting-title-compact">{{ upcomingMeeting.meeting.meeting_name_mal && upcomingMeeting.meeting.meeting_name_mal !== 'N' ? upcomingMeeting.meeting.meeting_name_mal : upcomingMeeting.meeting.meeting_name }}</h3>
                                <span class="status-badge price mal-text">
                                    <ion-icon name="checkmark-circle-outline" class="price-icon" title="Conducted"></ion-icon>
                                </span>
                            </div>
                            <div class="meeting-info-compact">
                                <span class="info-item">
                                    <ion-icon name="calendar-outline"></ion-icon>
                                    {{ upcomingMeeting.meeting.meeting_date ? upcomingMeeting.meeting.meeting_date : '--/--/----' }}
                                </span>
                                <span class="info-separator">/</span>
                                <span class="info-item">
                                    <ion-icon name="time-outline"></ion-icon>
                                    {{ upcomingMeeting.meeting.meeting_time ? upcomingMeeting.meeting.meeting_time : '--:--' }}
                                </span>
                                <span class="info-separator">/</span>
                                <span class="info-item">
                                    <ion-icon name="people-outline"></ion-icon>
                                    {{ upcomingMeeting.participants_count ? upcomingMeeting.participants_count : '---' }}
                                </span>
                            </div>
                            <div class="meeting-location-compact">
                                <ion-icon name="location-outline"></ion-icon>
                                <span>{{ upcomingMeeting.meeting.meeting_location ? upcomingMeeting.meeting.meeting_location : '---' }}</span>
                            </div>
                        </div>
                    </router-link>
                     <!-- <div class="progress">
                        <div class="progress-bar" role="progressbar" style="width: 85%;" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100">85%</div>
                    </div> -->
                </div>
            </div>
            <!-- * item -->
        </div>

        <!-- Old -->
        <div class="goals" v-if="tabOld && !loading">
            <!-- item -->
            <div class="meeting-grid">
                <div class="meeting-card" v-for="oldMeeting in responseData.list" :key="oldMeeting.id">
                    <router-link :to="'meeting/' + oldMeeting.meeting_id" class="meeting-link">
                        <div class="in">
                            <div class="meeting-header-compact">
                                <h3 class="meeting-title-compact">{{ oldMeeting.meeting.meeting_name_mal && oldMeeting.meeting.meeting_name_mal !== 'N' ? oldMeeting.meeting.meeting_name_mal : oldMeeting.meeting.meeting_name }}</h3>
                                <span class="status-badge price mal-text">
                                    <ion-icon name="checkmark-circle-outline" class="price-icon" title="Conducted"></ion-icon>
                                </span>
                            </div>
                            <div class="meeting-info-compact">
                                <span class="info-item">
                                    <ion-icon name="calendar-outline"></ion-icon>
                                    {{ oldMeeting.meeting.meeting_date ? oldMeeting.meeting.meeting_date : '--/--/----' }}
                                </span>
                                <span class="info-separator">/</span>
                                <span class="info-item">
                                    <ion-icon name="time-outline"></ion-icon>
                                    {{ oldMeeting.meeting.meeting_time ? oldMeeting.meeting.meeting_time : '--:--' }}
                                </span>
                                <span class="info-separator">/</span>
                                <span class="info-item">
                                    <ion-icon name="people-outline"></ion-icon>
                                    {{ oldMeeting.participants_count ? oldMeeting.participants_count : '---' }}
                                </span>
                            </div>
                            <div class="meeting-location-compact">
                                <ion-icon name="location-outline"></ion-icon>
                                <span>{{ oldMeeting.meeting.meeting_location ? oldMeeting.meeting.meeting_location : '---' }}</span>
                            </div>
                        </div>
                    </router-link>
                     <!-- <div class="progress">
                        <div class="progress-bar" role="progressbar" style="width: 85%;" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100">85%</div>
                    </div> -->
                </div>
            </div>
            <!-- * item -->
        </div>

        <!-- My Assignments -->
        <div class="goals" v-if="tabAssignments && !loading">
            <div class="meeting-grid">
                <div class="assignment-card" v-for="assignment in assignmentsList" :key="assignment.id">
                    <div class="assignment-content">
                        <div class="assignment-header">
                            <h3 class="assignment-title">{{ assignment.minutes || assignment.task || 'Task' }}</h3>
                            <span class="status-badge price mal-text">
                                <ion-icon name="checkmark-circle-outline" class="price-icon" title="Conducted"></ion-icon>
                            </span>
                        </div>
                        <div class="assignment-info">
                            <div class="assignment-detail" v-if="assignment.meeting">
                                <ion-icon name="calendar-outline"></ion-icon>
                                <span class="assignment-label">Meeting:</span>
                                <span class="assignment-value">{{ assignment.meeting.meeting_name_mal && assignment.meeting.meeting_name_mal !== 'N' ? assignment.meeting.meeting_name_mal : assignment.meeting.meeting_name }}</span>
                            </div>
                            <div class="assignment-detail" v-if="assignment.meeting && assignment.meeting.meeting_date">
                                <ion-icon name="calendar-outline"></ion-icon>
                                <span class="assignment-label">Meeting Date:</span>
                                <span class="assignment-value">{{ formatDate(assignment.meeting.meeting_date) }}</span>
                            </div>
                            <div class="assignment-detail" v-if="assignment.due_date">
                                <ion-icon name="time-outline"></ion-icon>
                                <span class="assignment-label">Due Date:</span>
                                <span class="assignment-value">{{ formatDate(assignment.due_date) }}</span>
                            </div>
                            <div class="assignment-detail">
                                <ion-icon name="flag-outline"></ion-icon>
                                <span class="assignment-label">Status:</span>
                                <select 
                                    class="form-control assignment-status-select"
                                    :class="getStatusClass(assignment.status)"
                                    :value="assignment.status || 'Assigned'"
                                    :data-assignment-id="assignment.id"
                                    @change="updateAssignmentStatus(assignment.id, $event.target.value, $event)"
                                    :disabled="loading">
                                    <option value="Assigned">Assigned</option>
                                    <option value="In Progress">In Progress</option>
                                    <option value="On Hold">On Hold</option>
                                    <option value="Completed">Completed</option>
                                </select>
                            </div>
                            <div class="assignment-detail assignment-remarks-field">
                                <div class="assignment-remarks-header">
                                    <ion-icon name="document-text-outline"></ion-icon>
                                    <span class="assignment-label">Remarks:</span>
                                </div>
                                <div class="assignment-remarks-list">
                                    <div 
                                        v-for="(remark, rIdx) in getAssignmentRemarksList(assignment)" 
                                        :key="'r-' + assignment.id + '-' + rIdx" 
                                        class="assignment-remark-item">
                                        <span class="assignment-remark-text">{{ remark.text || remark }}</span>
                                        <button 
                                            type="button" 
                                            class="assignment-remark-remove" 
                                            @click="removeRemark(assignment, rIdx)"
                                            :disabled="loading"
                                            title="Remove remark"
                                            aria-label="Remove remark">
                                            <ion-icon name="close-circle-outline"></ion-icon>
                                        </button>
                                    </div>
                                    <div class="assignment-remark-add">
                                        <textarea 
                                            class="form-control assignment-remarks-input assignment-remark-new"
                                            :data-assignment-id="assignment.id"
                                            v-model="remarkInputs[assignment.id]"
                                            @keydown.enter.exact.prevent="addRemark(assignment)"
                                            placeholder="Add a remark or note..."
                                            rows="1"
                                            :disabled="loading"></textarea>
                                        <button 
                                            type="button" 
                                            class="btn btn-sm assignment-remark-add-btn"
                                            @click="addRemark(assignment)"
                                            :disabled="loading || !(remarkInputs[assignment.id] || '').trim()">
                                            Add remark
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="assignment-actions" v-if="assignment.meeting_id">
                            <router-link :to="'meeting/' + assignment.meeting_id" class="view-meeting-link">
                                <ion-icon name="eye-outline"></ion-icon>
                                <span>View Meeting</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="assignmentsList.length === 0 && !loading" class="no-assignments-message">
                <h3 class="text-center mt-2 text-primary">No assignments found</h3>
            </div>
        </div>
    </div>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>

    <!-- Create Meeting Modal -->
    <div class="modal fade action-sheet" id="createMeetingModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Create Meeting</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <form @submit.prevent="createMeeting">
                            <div class="form-group basic">
                                <label class="label">Meeting Level <span class="text-danger">*</span></label>
                                <div class="input-wrapper">
                                    <select class="form-control custom-select" v-model="meetingForm.meeting_level" 
                                        @change="onMeetingLevelChange" required>
                                        <option value="">Select Meeting Level</option>
                                        <option value="1" v-if="user_level == 1">State</option>
                                        <option value="2" v-if="user_level <= 2">District</option>
                                        <option value="3" v-if="user_level <= 3">Zone</option>
                                        <!-- <option value="4">Unit</option> -->
                                    </select>
                                </div>
                            </div>

                            <!-- District picker for State admin when creating District-level meetings -->
                            <!-- Removed: state admins use their own district_id automatically -->

                            <!-- Level pickers for State/District admins when creating Zone meetings -->
                            <template v-if="parseInt(meetingForm.meeting_level) === 3 && user_level <= 2 && !isSpecialMeeting && !isSelfMeeting">
                                <div class="form-group basic">
                                    <label class="label">Zone <span class="text-danger">*</span></label>
                                    <div class="input-wrapper">
                                        <select class="form-control custom-select" v-model="meetingForm.zone_id" required>
                                            <option value="">Select Zone</option>
                                            <option v-for="z in zones" :key="z.id" :value="String(z.id)">{{ z.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </template>

                            <div class="form-group basic">
                                <label class="label">Meeting Sub Level <span class="text-danger">*</span></label>
                                <div class="input-wrapper">
                                    <select class="form-control custom-select" v-model="meetingForm.meeting_sublevel" 
                                        @change="onMeetingSubLevelChange" required>
                                        <option value="">Select Meeting Sub Level</option>
                                        <option value="1">Secretariat</option>
                                        <option value="2">Executive</option>
                                        <option value="3">Departmental</option>
                                        <option value="8">Special Meeting</option>
                                        <!-- <option value="4">General Body</option> -->
                                        <!-- <option value="5">Council</option> -->
                                        <!-- <option value="6">Joint Secretariat</option> -->
                                        <!-- <option value="7">Wisdom Day</option> -->
                                    </select>
                                </div>
                            </div>

                            <!-- Department: shown only when Departmental is selected in Meeting Sub Level -->
                            <div class="form-group basic" v-if="canShowDepartmentField">
                                <label class="label">Department</label>
                                <div class="input-wrapper">
                                    <select class="form-control custom-select" v-model="meetingForm.department_id"
                                        @change="onDepartmentChange">
                                        <option value="">Select Department</option>
                                        <option v-for="dept in departments" :key="dept.id" :value="dept.id">
                                            {{ dept.name_mal || dept.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Special Meeting: custom name and participant types -->
                            <template v-if="isSpecialMeeting">
                                <div class="form-group basic">
                                    <label class="label">Meeting Name <span class="text-danger">*</span></label>
                                    <div class="input-wrapper">
                                        <input type="text" class="form-control" v-model="meetingForm.meeting_name"
                                            placeholder="e.g. Coordination Meeting" required>
                                    </div>
                                </div>
                                <div class="form-group basic">
                                    <label class="label">Add Participants <span class="text-danger">*</span></label>
                                    <p class="text-muted small mb-2">Select who should participate in this special meeting.</p>
                                    <div class="special-meeting-participants">
                                        <label class="participant-option" v-for="opt in specialMeetingParticipantOptions" :key="opt.value">
                                            <input type="checkbox" :value="opt.value" v-model="meetingForm.special_meeting_participant_types">
                                            <span>{{ opt.label }}</span>
                                        </label>
                                    </div>
                                </div>
                            </template>

                            <!-- Self Meeting: only Meeting Name; creator is the only participant -->
                            <template v-if="isSelfMeeting">
                                <div class="form-group basic">
                                    <label class="label">Meeting Name <span class="text-danger">*</span></label>
                                    <div class="input-wrapper">
                                        <input type="text" class="form-control" v-model="meetingForm.meeting_name"
                                            placeholder="e.g. Personal Planning" required>
                                    </div>
                                </div>
                            </template>

                            <!-- Department Meeting: select participant groups separately -->
                            <template v-if="isDepartmentMeeting">
                                <div class="form-group basic">
                                    <label class="label">Participants <span class="text-danger">*</span></label>
                                    <p class="text-muted small mb-2">Select participant groups for this department meeting.</p>
                                    <div class="department-meeting-participants">
                                        <div class="participant-select-row"
                                            v-for="convenor in departmentMeetingConvenorGroups" :key="convenor.key">
                                            <label class="participant-select-label">{{ convenor.label }}</label>
                                            <select class="form-control custom-select"
                                                v-model="meetingForm.department_meeting_participants[convenor.key]"
                                                @change="onDepartmentParticipantChange">
                                                <option value="">Select</option>
                                                <option value="yes">Include</option>
                                            </select>
                                        </div>

                                        <div class="participant-group-block"
                                            v-for="group in departmentMeetingSecretariatGroups" :key="group.key">
                                            <div class="participant-select-row">
                                                <label class="participant-select-label">{{ group.label }}</label>
                                                <select class="form-control custom-select"
                                                    v-model="meetingForm.department_meeting_participants[group.key].enabled"
                                                    @change="onSecretariatGroupChange(group.key)">
                                                    <option value="">Select</option>
                                                    <option value="yes">Include</option>
                                                </select>
                                            </div>
                                            <div v-if="meetingForm.department_meeting_participants[group.key].enabled === 'yes'"
                                                class="secretariat-role-options">
                                                <label class="participant-select-label">Select Roles</label>
                                                <div class="special-meeting-participants">
                                                    <label class="participant-option"
                                                        v-for="role in secretariatRoleOptions" :key="role.value">
                                                        <input type="checkbox" :value="role.value"
                                                            v-model="meetingForm.department_meeting_participants[group.key].roles"
                                                            @change="onDepartmentParticipantChange">
                                                        <span>{{ role.label }}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <div class="form-group basic">
                                <label class="label">Date <span class="text-danger">*</span></label>
                                <div class="input-wrapper">
                                    <input type="date" class="form-control" v-model="meetingForm.meeting_date" required>
                                </div>
                            </div>

                            <div class="form-group basic">
                                <label class="label">Time</label>
                                <div class="input-wrapper">
                                    <input type="time" class="form-control" v-model="meetingForm.meeting_time">
                                </div>
                            </div>

                            <div class="form-group basic">
                                <label class="label">Meeting Mode</label>
                                <div class="input-wrapper">
                                    <select class="form-control custom-select" v-model="meetingForm.meeting_mode">
                                        <option value="">Select Mode</option>
                                        <option value="Online">Online</option>
                                        <option value="Physical">Physical</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group basic">
                                <label class="label">Status</label>
                                <div class="input-wrapper">
                                    <select class="form-control custom-select" v-model="meetingForm.status_level">
                                        <option value="1">തീരുമാനിച്ചിട്ടില്ല</option>
                                        <option value="2">തീരുമാനം ആയി</option>
                                        <option value="3">നടന്നില്ല</option>
                                        <option value="4">നടന്നു</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group basic">
                                <label class="label">Location</label>
                                <div class="input-wrapper">
                                    <input type="text" class="form-control" v-model="meetingForm.meeting_location" 
                                        placeholder="Enter meeting location">
                                </div>
                            </div>

                            <div class="form-group basic">
                                <label class="label">Link</label>
                                <div class="input-wrapper">
                                    <input type="url" class="form-control" v-model="meetingForm.meeting_url" 
                                        placeholder="Enter meeting link (for online meetings)">
                                </div>
                            </div>

                            <div class="form-group basic" v-if="participantsCount > 0 || meetingForm.meeting_name">
                                <div class="participants-count-info">
                                    <div class="info-content-compact">
                                        <div class="info-row-compact" v-if="meetingForm.meeting_name">
                                            <span class="info-label-compact">Meeting Name:</span>
                                            <span class="info-text-compact">{{ meetingForm.meeting_name }}</span>
                                        </div>
                                        <div class="info-row-compact" v-if="participantsCount > 0">
                                            <ion-icon name="people-outline"></ion-icon>
                                            <span class="info-label-compact">Participant Count:</span>
                                            <span class="count-value-compact">{{ participantsCount }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>Create</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import { Form, Field } from "vee-validate";
import UserService from "../../services/user.service";
import { fetchUpcomingMeetingsIndicator } from "../../services/meetingsIndicator.service";
import AlertModel from "../layouts/AlertModel.vue";
import DialogModel from "../layouts/DialogModel.vue";
import $ from 'jquery';
export default {
    name: 'Organization',
    components: {
        // Form,
        // Field,
        AlertModel,
        DialogModel
    },
    data() {
        return {
            loading: false,
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            tabHome: true,
            tabUpcoming: false,
            tabOld: false,
            tabAssignments: false,
            responseData: {
                meeting: [],
                participants: [],
                agenda: [],
                minutes: [],
                list: []
            },
            assignmentsList: [],

            message: "",
            user_level: "",
            permissions: [],
            sub_levels: [],
            sub_level_list_name: "",
            user_level_id: "",
            unit: [],
            nerpatham_target: '',
            sub_level_id: '',

            sub_level: [],
            meetingForm: {
                meeting_level: '',
                meeting_sublevel: '',
                department_id: '',
                meeting_name: '',
                meeting_date: '',
                meeting_time: '',
                meeting_mode: '',
                status_level: '1',
                meeting_location: '',
                meeting_url: '',
                special_meeting_participant_types: [],
                department_meeting_participants: {
                    state_wing_convenors: '',
                    district_wing_convenors: '',
                    zone_wing_convenors: '',
                    unit_wing_convenors: '',
                    state_secretariat: { enabled: '', roles: [] },
                    district_secretariat: { enabled: '', roles: [] },
                    zone_secretariat: { enabled: '', roles: [] },
                    unit_secretariat: { enabled: '', roles: [] }
                },
                district_id: '',
                zone_id: ''
            },
            departments: [],
            districts: [],
            zones: [],
            districtName: '',
            zoneName: '',
            meetingSubLevelMap: {
                '1': 'Secretariat',
                '2': 'Executive',
                '3': 'Departmental',
                '4': 'General Body',
                '5': 'Council',
                '6': 'Joint Secretariat',
                '7': 'Wisdom Day',
                '8': 'Special Meetings',
            },
            participantsCount: 0,
            remarkInputs: {}, // assignmentId -> string for "add remark" input
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        todayMeetings() {
            if (!this.responseData.list || !Array.isArray(this.responseData.list)) {
                return [];
            }
            
            // Get today's date in YYYY-MM-DD format
            const today = new Date();
            const todayStr = today.toISOString().split('T')[0]; // Format: YYYY-MM-DD
            
            // Filter meetings that match today's date
            return this.responseData.list.filter(meeting => {
                if (!meeting.meeting || !meeting.meeting.meeting_date) {
                    return false;
                }
                
                // Handle different date formats
                const meetingDate = meeting.meeting.meeting_date;
                
                // If date is already in YYYY-MM-DD format
                if (meetingDate === todayStr) {
                    return true;
                }
                
                // Try to parse other date formats
                try {
                    const parsedDate = new Date(meetingDate);
                    const parsedDateStr = parsedDate.toISOString().split('T')[0];
                    return parsedDateStr === todayStr;
                } catch (e) {
                    return false;
                }
            });
        },
        isSpecialMeeting() {
            return this.meetingForm.meeting_sublevel === '8' || parseInt(this.meetingForm.meeting_sublevel) === 8;
        },
        isSelfMeeting() {
            return this.meetingForm.meeting_sublevel === '9' || parseInt(this.meetingForm.meeting_sublevel) === 9;
        },
        isDepartmentalSubLevel() {
            return this.meetingForm.meeting_sublevel === '3'
                || parseInt(this.meetingForm.meeting_sublevel) === 3;
        },
        canShowDepartmentField() {
            if (!this.isDepartmentalSubLevel || this.isSpecialMeeting || this.isSelfMeeting) {
                return false;
            }
            const level = parseInt(this.meetingForm.meeting_level);
            if (!level) {
                return false;
            }
            if (this.user_level == 1 && level >= 1 && level <= 3) {
                return true;
            }
            if (this.user_level == 2 && level >= 2 && level <= 3) {
                return true;
            }
            if (this.user_level == 3 && level === 3) {
                return true;
            }
            return false;
        },
        isDepartmentMeeting() {
            return this.isDepartmentalSubLevel
                && !!this.meetingForm.department_id;
        },
        departmentMeetingConvenorGroups() {
            const level = parseInt(this.meetingForm.meeting_level);
            const groups = [
                // State wing convenors omitted at state level — meeting is already state-level
                { key: 'district_wing_convenors', label: 'District Wing Convenors', levels: [1, 2] },
                { key: 'zone_wing_convenors', label: 'Zone Wing Convenors', levels: [1, 2] },
                { key: 'unit_wing_convenors', label: 'Unit Wing Convenors', levels: [1, 2, 3] },
            ];
            return groups.filter((group) => group.levels.includes(level));
        },
        secretariatRoleOptions() {
            return [
                { value: 'president', label: 'President' },
                { value: 'vice_president', label: 'Vice President' },
                { value: 'secretary', label: 'Secretary' },
                { value: 'joint_secretary', label: 'Joint Secretary' },
                { value: 'treasurer', label: 'Treasurer' },
            ];
        },
        departmentMeetingSecretariatGroups() {
            const level = parseInt(this.meetingForm.meeting_level);
            const groups = [
                // State secretariat omitted at state level — meeting is already state-level
                { key: 'district_secretariat', prefix: 'district', label: 'District Secretariat', levels: [1, 2] },
                { key: 'zone_secretariat', prefix: 'zone', label: 'Zone Secretariat', levels: [1, 2] },
                { key: 'unit_secretariat', prefix: 'unit', label: 'Unit Secretariat', levels: [1, 2, 3] },
            ];
            return groups.filter((group) => group.levels.includes(level));
        },
        specialMeetingParticipantOptions() {
            const level = parseInt(this.meetingForm.meeting_level);
            const baseOptions = [
                { value: 'self_meeting', label: 'Self Meeting' },
            ];
            const stateOptions = [
                { value: 'state_secretariat', label: 'State Secretariat' },
                { value: 'state_executive', label: 'State Executive' }
            ];
            const unitZone = [
                { value: 'unit_secretariat', label: 'Unit Secretariat' },
                { value: 'unit_executive', label: 'Unit Executive' },
                { value: 'zone_secretariat', label: 'Zone Secretariat' },
                { value: 'zone_executive', label: 'Zone Executive' }
            ];
            const districtSecretariat = { value: 'district_secretariat', label: 'District Secretariat' };
            const districtExecutive = { value: 'district_executive', label: 'District Executive' };
            if (level === 1) return [...baseOptions, ...stateOptions, ...unitZone, districtSecretariat, districtExecutive]; // State: self + state secretariat + state exec + unit + zone + district secretariat + district executive
            if (level === 2) return [...baseOptions, ...unitZone, districtSecretariat, districtExecutive]; // District: self + unit + zone + district secretariat + district executive
            if (level === 3) return [...baseOptions, ...unitZone]; // Zone: self + unit + zone (4)
            return [...baseOptions, ...unitZone.slice(0, 2)]; // fallback: self + unit only
        }
    },
    watch: {
        'meetingForm.meeting_level'() {
            if (this.isDepartmentalSubLevel) {
                this.meetingForm.department_id = '';
                this.resetDepartmentMeetingParticipants();
                this.$nextTick(() => this.loadDepartmentsForMeetingLevel());
            }
            if (this.canFetchParticipantsCount()) {
                this.getParticipantsCount();
            }
        },
        'meetingForm.meeting_sublevel'(val) {
            if (parseInt(val, 10) === 3) {
                this.$nextTick(() => this.loadDepartmentsForMeetingLevel());
            } else {
                this.meetingForm.department_id = '';
                this.resetDepartmentMeetingParticipants();
                this.departments = [];
            }
        },
        'meetingForm.district_id'() {
            const level = parseInt(this.meetingForm.meeting_level);
            if (level === 3 && this.user_level == 1) {
                this.meetingForm.zone_id = '';
                this.fetchZonesForDistrict();
            }
            if (this.canFetchParticipantsCount()) {
                this.getParticipantsCount();
            }
        },
        'meetingForm.zone_id'() {
            if (this.canFetchParticipantsCount()) {
                this.getParticipantsCount();
            }
        },
        'meetingForm.department_id'() {
            if (this.canFetchParticipantsCount()) {
                this.getParticipantsCount();
            }
        },
        'meetingForm.department_meeting_participants': {
            handler() {
                if (this.isDepartmentMeeting) {
                    this.getParticipantsCount();
                }
            },
            deep: true
        },
        'meetingForm.special_meeting_participant_types': {
            handler() {
                if (this.isSpecialMeeting) {
                    this.getParticipantsCount();
                }
            },
            deep: true
        },
        '$route'(to) {
            // Handle route changes, especially when navigating back to /meetings
            if (to.path === '/meetings') {
                const tabQuery = to.query.tab;
                // Only update tab if query param changed
                if (tabQuery === 'upcoming' && !this.tabUpcoming) {
                    this.goToTab('Upcoming');
                } else if (tabQuery === 'old' && !this.tabOld) {
                    this.goToTab('Old');
                } else if (tabQuery === 'assignments' && !this.tabAssignments) {
                    this.goToTab('Assignments');
                } else if (!tabQuery && !this.tabHome) {
                    // No query param means Home tab
                    this.goToTab('Home');
                }
            }
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = this.currentUser.user_level;
            this.$root.updateParent("Loading...");
            if (this.user_level == 1) {
                this.user_level_id = 0;
            } else if (this.user_level == 2) {
                this.user_level_id = this.currentUser.district_id;
            }
            else if (this.user_level == 3) {
                this.user_level_id = this.currentUser.zone_id;
            }
            else if (this.user_level == 4) {
                this.user_level_id = this.currentUser.unit_id;
            }
            
            // Check route query for tab state on initial load
            const tabQuery = this.$route.query.tab;
            if (tabQuery === 'upcoming') {
                this.tabUpcoming = true;
                this.getMeetings('Upcoming');
            } else if (tabQuery === 'old') {
                this.tabOld = true;
                this.getMeetings('Old');
            } else if (tabQuery === 'assignments') {
                this.tabAssignments = true;
                this.getMyAssignments();
            } else {
                // Default to Home tab (no query param)
                this.tabHome = true;
                this.getMeetings('Home');
            }

            this.refreshMeetingsIndicator();
            
            if (this.user_level <= 2) {
                this.bootstrapMeetingLocationPickers();
            }
        }
    },
    methods: {
        async bootstrapMeetingLocationPickers() {
            const districtId = this.getEffectiveDistrictId();
            if (this.user_level == 2 && districtId) {
                await this.fetchZonesForDistrict(districtId);
            } else if (this.user_level == 1 && districtId) {
                await this.fetchZonesForDistrict(districtId);
            }
        },
        getEffectiveDistrictId() {
            if (this.currentUser && this.currentUser.district_id) {
                return parseInt(this.currentUser.district_id, 10);
            }
            if (this.meetingForm.district_id) {
                return parseInt(this.meetingForm.district_id, 10);
            }
            return null;
        },
        applyUserDistrictContext() {
            const districtId = this.getEffectiveDistrictId();
            if (districtId) {
                this.meetingForm.district_id = String(districtId);
            }
        },
        getDepartmentListUserLevel() {
            const meetingLevel = parseInt(this.meetingForm.meeting_level, 10);
            if (!meetingLevel) {
                return parseInt(this.user_level, 10);
            }
            // State-level departmental meetings use the district department catalog
            if (meetingLevel === 1) {
                return 2;
            }
            return meetingLevel;
        },
        async fetchDistricts() {
            try {
                const res = await UserService.getSubLevels('get-sub-levels', { sub_level_type: 2, id: 0 });
                this.districts = (res.data && res.data.data && res.data.data.list) ? res.data.data.list : [];
            } catch (e) {
                this.districts = [];
            }
        },
        async fetchZonesForDistrict(districtIdParam = null) {
            const districtId = districtIdParam || this.getEffectiveDistrictId();
            if (!districtId) {
                this.zones = [];
                return;
            }
            try {
                const res = await UserService.getSubLevels('get-sub-levels', { sub_level_type: 3, id: parseInt(String(districtId), 10) });
                this.zones = (res.data && res.data.data && res.data.data.list) ? res.data.data.list : [];
            } catch (e) {
                this.zones = [];
            }
        },
        goToTab(tab) {
            // Prevent unnecessary updates if already on the target tab
            if ((tab == 'Home' && this.tabHome) || 
                (tab == 'Upcoming' && this.tabUpcoming) || 
                (tab == 'Old' && this.tabOld) || 
                (tab == 'Assignments' && this.tabAssignments)) {
                return;
            }
            
            this.loading = true;
            this.tabHome = false;
            this.tabUpcoming = false;
            this.tabOld = false;
            this.tabAssignments = false;
            
            if (tab == 'Home') {
                this.tabHome = true;
                this.getMeetings('Home');
                // Remove query param for Home tab to keep URL clean
                if (this.$route.query.tab) {
                    this.$router.replace({ path: '/meetings', query: {} });
                }
            } else if (tab == 'Upcoming') {
                this.tabUpcoming = true;
                this.getMeetings('Upcoming');
                // Update route query to track tab state
                if (this.$route.query.tab !== 'upcoming') {
                    this.$router.replace({ path: '/meetings', query: { tab: 'upcoming' } });
                }
            } else if (tab == 'Assignments') {
                this.tabAssignments = true;
                this.getMyAssignments();
                // Update route query to track tab state
                if (this.$route.query.tab !== 'assignments') {
                    this.$router.replace({ path: '/meetings', query: { tab: 'assignments' } });
                }
            } else {
                this.tabOld = true;
                this.getMeetings('Old');
                // Update route query to track tab state
                if (this.$route.query.tab !== 'old') {
                    this.$router.replace({ path: '/meetings', query: { tab: 'old' } });
                }
            }
        },

        async refreshMeetingsIndicator() {
            if (!this.currentUser) {
                this.$store.commit('app/setHasUpcomingMeetings', false);
                return;
            }
            try {
                const hasUpcoming = await fetchUpcomingMeetingsIndicator();
                this.$store.commit('app/setHasUpcomingMeetings', hasUpcoming);
            } catch {
                this.$store.commit('app/setHasUpcomingMeetings', false);
            }
        },
        getMeetings(type) {
            this.loading = true;
            let data = {
                type: type
            }
            UserService.authPostRequest('get-meetings', data).then(
                (response) => {

                    if (response.data.status == 'success') {
                        this.loading = false;
                        let list = response.data.data.list || [];
                        if (type === 'Upcoming') {
                            this.$store.commit('app/setHasUpcomingMeetings', list.length > 0);
                        }
                        
                        // Sort by date and time descending (Newest first)
                        // This fixes the "mixed" order issue
                        list.sort((a, b) => {
                            const dateA = a.meeting.meeting_date || '';
                            const timeA = a.meeting.meeting_time || '';
                            const dateB = b.meeting.meeting_date || '';
                            const timeB = b.meeting.meeting_time || '';
                            
                            // Compare dates
                            if (dateA !== dateB) {
                                return dateB.localeCompare(dateA);
                            }
                            // If dates are equal, compare times
                            return timeB.localeCompare(timeA);
                        });
                        
                        this.responseData = response.data.data;
                        this.responseData.list = list;
                        this.$root.updateParent('Meetings');
                    } else {
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.data.message;
                    this.$refs.alert_model.openModel();
                }
            );
        },
        getMyAssignments() {
            this.loading = true;
            UserService.authPostRequest('get-my-assignments', {}).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.loading = false;
                        this.assignmentsList = response.data.data.list || response.data.data || [];
                        this.assignmentsList.forEach(a => {
                            this.$set(this.remarkInputs, a.id, this.remarkInputs[a.id] || '');
                        });
                        // Sort by latest activity first (updated_at desc, fallback created_at)
                        // so newly added/updated tasks appear at the top.
                        const ts = (v) => {
                            if (!v) return 0;
                            const t = Date.parse(v);
                            return Number.isFinite(t) ? t : 0;
                        };
                        this.assignmentsList.sort((a, b) => {
                            const aT = ts(a.updated_at) || ts(a.created_at) || 0;
                            const bT = ts(b.updated_at) || ts(b.created_at) || 0;
                            if (aT !== bT) return bT - aT;
                            // Stable-ish fallback
                            return (parseInt(b.id, 10) || 0) - (parseInt(a.id, 10) || 0);
                        });
                    } else {
                        this.loading = false;
                        this.assignmentsList = [];
                    }
                },
                (error) => {
                    this.loading = false;
                    this.assignmentsList = [];
                    console.error('Error fetching assignments:', error);
                }
            );
        },
        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        },
        getStatusColor(status) {
            if (!status) return '';
            const statusLower = status.toLowerCase();
            switch (statusLower) {
                case 'assigned':
                    return 'color: #007bff; font-weight: 600;'; // Blue
                case 'in progress':
                    return 'color: #ffc107; font-weight: 600;'; // Yellow/Orange
                case 'on hold':
                    return 'color: #ff9800; font-weight: 600;'; // Orange
                case 'completed':
                    return 'color: #28a745; font-weight: 600;'; // Green
                default:
                    return 'color: #6c757d; font-weight: 600;'; // Gray
            }
        },
        getStatusClass(status) {
            if (!status) return 'status-assigned';
            const s = (status || 'Assigned').toLowerCase().replace(/\s+/g, '-');
            return 'status-' + (s === 'in-progress' ? 'in-progress' : s);
        },
        getAssignmentRemarksList(assignment) {
            if (!assignment) return [];
            if (Array.isArray(assignment.remarks_list)) return assignment.remarks_list;
            const raw = assignment.notes || assignment.remark || '';
            if (!raw || typeof raw !== 'string') return [];
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed)) {
                    assignment.remarks_list = parsed.map(r => typeof r === 'string' ? { text: r } : r);
                    return assignment.remarks_list;
                }
            } catch (_) {
                // JSON parse failed; fall through to treat as single remark
            }
            const single = raw.trim();
            assignment.remarks_list = single ? [{ text: single }] : [];
            return assignment.remarks_list;
        },
        addRemark(assignment) {
            const id = assignment.id;
            const val = (this.remarkInputs[id] || '').trim();
            if (!val) return;
            const list = this.getAssignmentRemarksList(assignment);
            list.push({ text: val });
            assignment.remarks_list = list;
            this.$set(this.remarkInputs, id, '');
            this.saveAssignmentRemarks(assignment);
        },
        removeRemark(assignment, index) {
            const list = this.getAssignmentRemarksList(assignment);
            if (index < 0 || index >= list.length) return;
            list.splice(index, 1);
            assignment.remarks_list = list;
            this.saveAssignmentRemarks(assignment);
        },
        saveAssignmentRemarks(assignment) {
            const list = assignment.remarks_list || [];
            const notesPayload = list.length ? JSON.stringify(list) : '';
            const data = {
                assignment_id: parseInt(assignment.id),
                notes: notesPayload
            };
            this.loading = true;
            UserService.authPostRequest('update-assignment-remarks', data).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status == 'success') {
                        const a = this.assignmentsList.find(x => x.id == assignment.id);
                        if (a) {
                            a.notes = notesPayload;
                            a.remark = list.length ? list.map(r => r.text || r).join('; ') : '';
                        }
                        this.alert_type = 'Success';
                        this.alert_message = 'Remarks updated.';
                        this.$refs.alert_model.openModel();
                    } else {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message || 'Failed to update remarks.';
                        this.$refs.alert_model.openModel();
                        this.getMyAssignments();
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || 'Something went wrong.';
                    this.$refs.alert_model.openModel();
                    this.getMyAssignments();
                }
            );
        },
        updateAssignmentStatus(assignmentId, newStatus, event) {
            const selectElement = event ? event.target : null;
            
            // Validate inputs
            if (!assignmentId) {
                this.alert_type = 'Error';
                this.alert_message = 'Assignment ID is missing. Please refresh the page and try again.';
                this.$refs.alert_model.openModel();
                // Reset to original value if element exists
                if (selectElement) {
                    const originalValue = selectElement.getAttribute('data-original-value') || 'Assigned';
                    selectElement.value = originalValue;
                }
                return;
            }
            
            if (!newStatus) {
                this.alert_type = 'Error';
                this.alert_message = 'Please select a valid status.';
                this.$refs.alert_model.openModel();
                // Reset to original value if element exists
                if (selectElement) {
                    const originalValue = selectElement.getAttribute('data-original-value') || 'Assigned';
                    selectElement.value = originalValue;
                }
                return;
            }
            
            // Store original value for rollback on error
            if (selectElement && !selectElement.getAttribute('data-original-value')) {
                const currentValue = selectElement.value;
                selectElement.setAttribute('data-original-value', currentValue);
            }
            
            this.loading = true;
            const data = {
                assignment_id: parseInt(assignmentId),
                status: newStatus
            };
            
            UserService.authPostRequest('update-assignment-status', data).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status == 'success') {
                        // Update the assignment in the list
                        const assignment = this.assignmentsList.find(a => a.id == assignmentId);
                        if (assignment) {
                            assignment.status = newStatus;
                        }
                        // Update the original value attribute
                        if (selectElement) {
                            selectElement.setAttribute('data-original-value', newStatus);
                        }
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message || 'Status updated successfully.';
                        this.$refs.alert_model.openModel();
                    } else {
                        this.loading = false;
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message || 'Failed to update status.';
                        this.$refs.alert_model.openModel();
                        // Reset to original value
                        if (selectElement) {
                            const originalValue = selectElement.getAttribute('data-original-value') || 'Assigned';
                            selectElement.value = originalValue;
                        }
                        // Reload assignments to get correct status
                        this.getMyAssignments();
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    
                    // Reset select to original value on error
                    if (selectElement) {
                        const originalValue = selectElement.getAttribute('data-original-value') || 'Assigned';
                        selectElement.value = originalValue;
                    }
                    
                    // Handle validation errors
                    if (error.response && error.response.data) {
                        if (error.response.data.errors) {
                            // Format validation errors
                            const errors = error.response.data.errors;
                            const errorMessages = [];
                            for (const field in errors) {
                                if (errors[field] && errors[field].length > 0) {
                                    const fieldName = field.replace('_', ' ');
                                    errorMessages.push(`${fieldName}: ${errors[field][0]}`);
                                }
                            }
                            this.alert_message = errorMessages.join(', ') || error.response.data.message || 'Validation error occurred.';
                        } else {
                            this.alert_message = error.response.data.message || 'Something went wrong. Please try again.';
                        }
                    } else {
                        this.alert_message = error.message || 'Something went wrong. Please try again.';
                    }
                    
                    this.$refs.alert_model.openModel();
                    // Reload assignments to get correct status
                    this.getMyAssignments();
                }
            );
        },
        handleRemarksBlur(assignmentId, event) {
            // Reset rows to 1 for compact display
            event.target.rows = 1;
            // Update remarks
            this.updateAssignmentRemarks(assignmentId, event.target.value, event);
        },
        updateAssignmentRemarks(assignmentId, remarks, event) {
            const textareaElement = event ? event.target : null;
            
            // Validate inputs
            if (!assignmentId) {
                return;
            }
            
            // Store original value for rollback on error
            if (textareaElement && !textareaElement.getAttribute('data-original-value')) {
                const currentValue = textareaElement.value;
                textareaElement.setAttribute('data-original-value', currentValue);
            }
            
            // Get current remarks value
            const currentRemarks = remarks || '';
            
            // Find assignment in list to check if value actually changed
            const assignment = this.assignmentsList.find(a => a.id == assignmentId);
            if (assignment) {
                const existingRemarks = assignment.notes || assignment.remark || '';
                // If value hasn't changed, don't make API call
                if (existingRemarks === currentRemarks) {
                    return;
                }
            }
            
            this.loading = true;
            const data = {
                assignment_id: parseInt(assignmentId),
                notes: currentRemarks
            };
            
            UserService.authPostRequest('update-assignment-remarks', data).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status == 'success') {
                        // Update the assignment in the list
                        const assignment = this.assignmentsList.find(a => a.id == assignmentId);
                        if (assignment) {
                            assignment.notes = currentRemarks;
                            assignment.remark = currentRemarks;
                        }
                        // Update the original value attribute
                        if (textareaElement) {
                            textareaElement.setAttribute('data-original-value', currentRemarks);
                        }
                        // Show success message only if there was a change
                        if (currentRemarks) {
                            this.alert_type = 'Success';
                            this.alert_message = 'Remarks updated successfully.';
                            this.$refs.alert_model.openModel();
                        }
                    } else {
                        this.loading = false;
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message || 'Failed to update remarks.';
                        this.$refs.alert_model.openModel();
                        // Reset to original value
                        if (textareaElement) {
                            const originalValue = textareaElement.getAttribute('data-original-value') || '';
                            textareaElement.value = originalValue;
                        }
                        // Reload assignments to get correct remarks
                        this.getMyAssignments();
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    
                    // Reset textarea to original value on error
                    if (textareaElement) {
                        const originalValue = textareaElement.getAttribute('data-original-value') || '';
                        textareaElement.value = originalValue;
                    }
                    
                    // Handle validation errors
                    if (error.response && error.response.data) {
                        if (error.response.data.errors) {
                            // Format validation errors
                            const errors = error.response.data.errors;
                            const errorMessages = [];
                            for (const field in errors) {
                                if (errors[field] && errors[field].length > 0) {
                                    const fieldName = field.replace('_', ' ');
                                    errorMessages.push(`${fieldName}: ${errors[field][0]}`);
                                }
                            }
                            this.alert_message = errorMessages.join(', ') || error.response.data.message || 'Validation error occurred.';
                        } else {
                            this.alert_message = error.response.data.message || 'Something went wrong. Please try again.';
                        }
                    } else {
                        this.alert_message = error.message || 'Something went wrong. Please try again.';
                    }
                    
                    this.$refs.alert_model.openModel();
                    // Reload assignments to get correct remarks
                    this.getMyAssignments();
                }
            );
        },
        clickSublevel(sub_level_id) {
            this.$router.push('/level-2-org/' + (this.user_level + 1) + '/' + sub_level_id);
        },
        nerpathamTarget(sub_level = null) {
            this.nerpatham_target = sub_level.nerpatham_target;
            this.sub_level_id = sub_level.id;
            $('#nerpathamTargetModel').modal('show');
        },
        addNerpathamTarget(data) {
            data.level = this.currentUser.user_level + 1;
            data.level_id = parseInt(this.sub_level_id);
            UserService.addAdmin('set-nerpatham-target', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.getSubLevels();
                        $('#nerpathamTargetModel').modal('hide')
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.message = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        async getDistrictName() {
            // Get district name if not available and district_id exists
            if (!this.districtName && this.currentUser.district_id) {
                try {
                    const response = await UserService.authPostRequest('get-district-by-id', {});
                    if (response.data.status === 'success') {
                        const districts = response.data.data.list || [];
                        const currentDistrict = districts.find(d => d.id == this.currentUser.district_id);
                        if (currentDistrict) {
                            this.districtName = currentDistrict.name;
                        }
                    }
                } catch (error) {
                    // Silent error handling
                    console.error('Error fetching district name:', error);
                }
            } else if (this.currentUser.district_name) {
                // Use district_name from currentUser if available
                this.districtName = this.currentUser.district_name;
            }
        },
        async getZoneName() {
            if (this.zoneName) return;
            const zid = this.currentUser && this.currentUser.zone_id ? parseInt(String(this.currentUser.zone_id), 10) : null;
            if (!zid) return;
            try {
                const response = await UserService.authPostRequest('get-zone-by-id', { id: zid });
                if (response.data && response.data.status === 'success') {
                    const z = response.data.data && response.data.data.list ? response.data.data.list : null;
                    if (z && z.name) {
                        this.zoneName = z.name;
                    }
                }
            } catch (error) {
                console.error('Error fetching zone name:', error);
            }
        },
        async openCreateMeetingModal() {
            // Reset form
            this.meetingForm = {
                meeting_level: '',
                meeting_sublevel: '',
                department_id: '',
                meeting_name: '',
                meeting_date: '',
                meeting_time: '',
                meeting_mode: '',
                status_level: '1',
                meeting_location: '',
                meeting_url: '',
                special_meeting_participant_types: [],
                department_meeting_participants: {
                    state_wing_convenors: '',
                    district_wing_convenors: '',
                    zone_wing_convenors: '',
                    unit_wing_convenors: '',
                    state_secretariat: { enabled: '', roles: [] },
                    district_secretariat: { enabled: '', roles: [] },
                    zone_secretariat: { enabled: '', roles: [] },
                    unit_secretariat: { enabled: '', roles: [] }
                },
                district_id: '',
                zone_id: ''
            };
            this.participantsCount = 0;
            // Set default meeting level based on user level
            if (this.user_level == 1) {
                this.meetingForm.meeting_level = '1';
            } else if (this.user_level == 2) {
                this.meetingForm.meeting_level = '2';
            } else if (this.user_level == 3) {
                this.meetingForm.meeting_level = '3';
            }
            // Preload zone list for the user's district (district/zone meeting targets)
            this.applyUserDistrictContext();
            await this.bootstrapMeetingLocationPickers();
            if (this.user_level == 3) {
                await this.getZoneName();
            }
            // Fetch district name if needed
            await this.getDistrictName();
            // Open modal using jQuery/bootstrap
            $('#createMeetingModal').modal('show');
        },
        getWingName(wing) {
            const wingNames = {
                '1': 'Wisdom',
                '2': 'Youth',
                '3': 'Students',
                '4': 'Women',
                '5': 'Balavedi',
                '6': 'Girls'
            };
            return wingNames[wing] || '';
        },
        getSelectedZoneName() {
            // Prefer selected zone from dropdown (State/District admin creating zone meetings)
            const zid = this.meetingForm.zone_id ? parseInt(String(this.meetingForm.zone_id), 10) : null;
            if (zid && Array.isArray(this.zones) && this.zones.length) {
                const z = this.zones.find(x => parseInt(String(x.id), 10) === zid);
                if (z && z.name) return z.name;
            }
            // Fallbacks for zone admin (if zone list wasn't loaded in this screen)
            if (this.currentUser && this.currentUser.zone_name) return this.currentUser.zone_name;
            if (this.currentUser && this.currentUser.zone && this.currentUser.zone.name) return this.currentUser.zone.name;
            if (this.zoneName) return this.zoneName;
            return '';
        },
        async updateMeetingName() {
            // Special Meeting / Self Meeting: user types the name; do not auto-set
            if (this.isSpecialMeeting || this.isSelfMeeting) {
                return;
            }
            // Department meeting: name from department only (no sub level)
            if (this.isDepartmentMeeting) {
                const wingName = this.getWingName(this.getUserWing());
                const dept = this.departments.find(d => String(d.id) === String(this.meetingForm.department_id));
                const level = parseInt(this.meetingForm.meeting_level);
                const parts = [];

                if (level === 1) {
                    if (wingName) parts.push(wingName);
                    parts.push('State');
                } else if (level === 2) {
                    if (!this.districtName) {
                        await this.getDistrictName();
                    }
                    if (this.districtName) parts.push(this.districtName);
                    if (wingName) parts.push(wingName);
                } else if (level === 3) {
                    if (!this.zoneName && this.user_level == 3) {
                        await this.getZoneName();
                    }
                    const zoneName = this.getSelectedZoneName() || this.zoneName;
                    if (!zoneName) {
                        this.meetingForm.meeting_name = '';
                        return;
                    }
                    parts.push(zoneName);
                    parts.push('zone');
                    if (wingName) parts.push(wingName);
                }

                if (dept && dept.name) parts.push(dept.name);
                parts.push('Department', 'Meeting');
                this.meetingForm.meeting_name = parts.join(' ');
                return;
            }
            // Automatically set meeting name:
            // - State: "[Wing] State [Secretariat/Executive] Meeting"
            // - District: "[District] [Wing] [Secretariat/Executive] Meeting"
            // - Zone: "[Zone] zone [Wing] [Secretariat/Executive] Meeting"
            if (this.meetingForm.meeting_sublevel && this.meetingSubLevelMap[this.meetingForm.meeting_sublevel]) {
                // Fetch district name if needed (for district level meetings)
                if (parseInt(this.meetingForm.meeting_level) == 2 && !this.districtName) {
                    await this.getDistrictName();
                }
                if (parseInt(this.meetingForm.meeting_level) == 3 && !this.zoneName && this.user_level == 3) {
                    await this.getZoneName();
                }
                
                const wingName = (this.currentUser && this.currentUser.wing) ? this.getWingName(this.currentUser.wing.toString()) : '';
                const subLevelName = this.meetingSubLevelMap[this.meetingForm.meeting_sublevel];
                const parts = [];
                
                if (parseInt(this.meetingForm.meeting_level) == 1) {
                    // State: "Students State Secretariat Meeting", "Youth QHLS Department Meeting"
                    if (wingName) parts.push(wingName);
                    parts.push('State');
                    if (this.meetingForm.department_id) {
                        const dept = this.departments.find(d => String(d.id) === String(this.meetingForm.department_id));
                        if (dept && dept.name) {
                            parts.push(dept.name);
                        }
                        parts.push('Department');
                    } else {
                        parts.push(subLevelName);
                    }
                    parts.push('Meeting');
                } else if (parseInt(this.meetingForm.meeting_level) == 2 && this.districtName) {
                    // District: "CALICUT SOUTH Students Secretariat Meeting", "DistrictName Youth Executive Meeting"
                    parts.push(this.districtName);
                    if (wingName) parts.push(wingName);
                    parts.push(subLevelName);
                    parts.push('Meeting');
                } else if (parseInt(this.meetingForm.meeting_level) == 3) {
                    const zoneName = this.getSelectedZoneName();
                    if (!zoneName) {
                        this.meetingForm.meeting_name = '';
                        return;
                    }
                    parts.push(zoneName);
                    parts.push('zone');
                    if (wingName) parts.push(wingName);
                    parts.push(subLevelName);
                    parts.push('Meeting');
                } else {
                    this.meetingForm.meeting_name = '';
                    return;
                }
                
                this.meetingForm.meeting_name = parts.join(' ');
            } else {
                this.meetingForm.meeting_name = '';
            }
        },
        async onMeetingLevelChange() {
            const level = parseInt(this.meetingForm.meeting_level);
            this.applyUserDistrictContext();
            if (level !== 3) {
                this.meetingForm.zone_id = '';
                this.zones = [];
            } else {
                await this.fetchZonesForDistrict();
            }
            if (this.isDepartmentalSubLevel) {
                this.loadDepartmentsForMeetingLevel();
            }
            // Update meeting name when level changes
            await this.updateMeetingName();
            if (this.canFetchParticipantsCount()) {
                this.getParticipantsCount();
            }
        },
        async onMeetingSubLevelChange() {
            const sublevel = parseInt(this.meetingForm.meeting_sublevel, 10);
            if (sublevel !== 3) {
                this.meetingForm.department_id = '';
                this.resetDepartmentMeetingParticipants();
                this.departments = [];
            } else {
                this.$nextTick(() => this.loadDepartmentsForMeetingLevel());
            }
            await this.updateMeetingName();
            this.getParticipantsCount();
        },
        onDepartmentChange() {
            if (!this.meetingForm.department_id) {
                this.resetDepartmentMeetingParticipants();
            }
            this.updateMeetingName();
            this.getParticipantsCount();
        },
        getUserWing() {
            const user = this.currentUser || {};
            const wing = user.wing ?? user.wing_id ?? user.wing_type;
            return wing != null && wing !== '' ? String(wing) : '1';
        },
        getMeetingWing() {
            if (this.meetingForm.department_id) {
                const dept = this.departments.find(
                    (d) => String(d.id) === String(this.meetingForm.department_id)
                );
                if (dept && dept.wing != null && dept.wing !== '') {
                    return String(dept.wing);
                }
            }
            return this.getUserWing();
        },
        getSelectedDepartment() {
            if (!this.meetingForm.department_id) {
                return null;
            }
            return this.departments.find(
                (d) => String(d.id) === String(this.meetingForm.department_id)
            ) || null;
        },
        appendSelectedDepartmentFields(data) {
            const dept = this.getSelectedDepartment();
            if (dept) {
                if (dept.name) {
                    data.department_name = dept.name;
                }
                if (dept.name_mal) {
                    data.department_name_mal = dept.name_mal;
                }
            }
            return data;
        },
        canFetchParticipantsCount() {
            if (!this.meetingForm.meeting_level) {
                return false;
            }
            if (this.isDepartmentalSubLevel) {
                return !!this.meetingForm.department_id;
            }
            return !!this.meetingForm.meeting_sublevel;
        },
        getMeetingSublevelForSave() {
            return parseInt(this.meetingForm.meeting_sublevel);
        },
        onDepartmentParticipantChange() {
            this.getParticipantsCount();
        },
        onSecretariatGroupChange(groupKey) {
            const group = this.meetingForm.department_meeting_participants[groupKey];
            if (!group || group.enabled !== 'yes') {
                if (group) {
                    group.roles = [];
                }
            }
            this.onDepartmentParticipantChange();
        },
        defaultDepartmentMeetingParticipants() {
            return {
                state_wing_convenors: '',
                district_wing_convenors: '',
                zone_wing_convenors: '',
                unit_wing_convenors: '',
                state_secretariat: { enabled: '', roles: [] },
                district_secretariat: { enabled: '', roles: [] },
                zone_secretariat: { enabled: '', roles: [] },
                unit_secretariat: { enabled: '', roles: [] }
            };
        },
        resetDepartmentMeetingParticipants() {
            this.meetingForm.department_meeting_participants = this.defaultDepartmentMeetingParticipants();
        },
        getSelectedDepartmentParticipantTypes() {
            const selected = [];
            const participants = this.meetingForm.department_meeting_participants || {};

            this.departmentMeetingConvenorGroups.forEach((convenor) => {
                if (participants[convenor.key] === 'yes') {
                    selected.push(convenor.key);
                }
            });

            this.departmentMeetingSecretariatGroups.forEach((group) => {
                const secretariat = participants[group.key];
                if (!secretariat || secretariat.enabled !== 'yes' || !Array.isArray(secretariat.roles)) {
                    return;
                }
                secretariat.roles.forEach((role) => {
                    selected.push(`${group.prefix}_${role}`);
                });
            });

            return selected;
        },
        getDepartmentMeetingValidationError() {
            const participants = this.meetingForm.department_meeting_participants || {};
            let hasSelection = this.departmentMeetingConvenorGroups.some(
                (convenor) => participants[convenor.key] === 'yes'
            );

            for (const group of this.departmentMeetingSecretariatGroups) {
                const secretariat = participants[group.key];
                if (!secretariat || secretariat.enabled !== 'yes') {
                    continue;
                }
                if (!Array.isArray(secretariat.roles) || secretariat.roles.length === 0) {
                    return `Please select at least one role for ${group.label}.`;
                }
                hasSelection = true;
            }

            if (!hasSelection) {
                return 'Please include at least one participant group for the department meeting.';
            }

            return '';
        },
        getParticipantsCount() {
            if (!this.canFetchParticipantsCount()) {
                this.participantsCount = 0;
                return;
            }

            // Self Meeting: only creator is participant
            if (this.isSelfMeeting) {
                this.participantsCount = 1;
                return;
            }

            const data = {
                meeting_level: parseInt(this.meetingForm.meeting_level),
                meeting_sublevel: this.getMeetingSublevelForSave(),
            };

            // Special Meeting: send selected participant types; count = 0 if none selected
            if (this.isSpecialMeeting) {
                const types = this.meetingForm.special_meeting_participant_types;
                if (!types || types.length === 0) {
                    this.participantsCount = 0;
                    return;
                }
                data.special_meeting_participant_types = types;
            }

            // Department Meeting: send selected participant categories
            if (this.isDepartmentMeeting) {
                const types = this.getSelectedDepartmentParticipantTypes();
                if (!types.length) {
                    this.participantsCount = 0;
                    return;
                }
                data.department_meeting_participant_types = types;
            }

            // Add district_id for district/zone level meetings (always user's district)
            const effectiveDistrictId = this.getEffectiveDistrictId();
            if (parseInt(this.meetingForm.meeting_level) == 2 && effectiveDistrictId) {
                data.district_id = effectiveDistrictId;
            }
            // Add zone_id for zone level meetings
            if (parseInt(this.meetingForm.meeting_level) == 3) {
                if (this.meetingForm.zone_id) {
                    data.zone_id = parseInt(this.meetingForm.zone_id);
                } else if (this.currentUser.zone_id) {
                    data.zone_id = this.currentUser.zone_id;
                }
            }

            // Add department_id if selected (non-special, non-self only)
            if (!this.isSpecialMeeting && !this.isSelfMeeting && this.meetingForm.department_id) {
                data.department_id = parseInt(this.meetingForm.department_id);
                this.appendSelectedDepartmentFields(data);
            }

            data.wing = this.getMeetingWing();

            UserService.authPostRequest('get-meeting-participants-count', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.participantsCount = response.data.data.count || 0;
                        // Auto-set wing if returned from API
                        if (response.data.data.wing && !this.meetingForm.wing) {
                            // Wing is already set from user, no need to set in form
                        }
                    } else {
                        this.participantsCount = 0;
                    }
                },
                (error) => {
                    console.error('Error fetching participants count:', error);
                    this.participantsCount = 0;
                }
            );
        },
        loadDepartmentsForMeetingLevel() {
            if (!this.canShowDepartmentField) {
                this.departments = [];
                return;
            }
            const data = {
                user_level: this.getDepartmentListUserLevel(),
                wing: this.getMeetingWing(),
            };
            UserService.authPostRequest('get-departments', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.departments = response.data.data.list || [];
                    } else {
                        this.departments = [];
                    }
                },
                (error) => {
                    console.error('Error fetching departments:', error);
                    this.departments = [];
                }
            );
        },
        createMeeting() {
            this.loading = true;

            if (!this.meetingForm.meeting_sublevel) {
                this.loading = false;
                this.alert_type = 'Warning';
                this.alert_message = 'Please select a meeting sub level.';
                this.$refs.alert_model.openModel();
                return;
            }

            if (this.isDepartmentalSubLevel && !this.meetingForm.department_id) {
                this.loading = false;
                this.alert_type = 'Warning';
                this.alert_message = 'Please select a department for the departmental meeting.';
                this.$refs.alert_model.openModel();
                return;
            }
            
            // Special Meeting: require name and at least one participant type
            if (this.isSpecialMeeting) {
                const name = (this.meetingForm.meeting_name || '').trim();
                const types = this.meetingForm.special_meeting_participant_types || [];
                if (!name) {
                    this.loading = false;
                    this.alert_type = 'Warning';
                    this.alert_message = 'Please enter a meeting name for the special meeting.';
                    this.$refs.alert_model.openModel();
                    return;
                }
                if (types.length === 0) {
                    this.loading = false;
                    this.alert_type = 'Warning';
                    this.alert_message = 'Please select at least one participant type for the special meeting.';
                    this.$refs.alert_model.openModel();
                    return;
                }
            }

            // Self Meeting: require name only; creator will be the only participant
            if (this.isSelfMeeting) {
                const name = (this.meetingForm.meeting_name || '').trim();
                if (!name) {
                    this.loading = false;
                    this.alert_type = 'Warning';
                    this.alert_message = 'Please enter a meeting name for the self meeting.';
                    this.$refs.alert_model.openModel();
                    return;
                }
            }

            // Department Meeting: require at least one participant group / role
            if (this.isDepartmentMeeting) {
                const validationError = this.getDepartmentMeetingValidationError();
                if (validationError) {
                    this.loading = false;
                    this.alert_type = 'Warning';
                    this.alert_message = validationError;
                    this.$refs.alert_model.openModel();
                    return;
                }
            }
            
            // Map status_level to status string
            const statusMap = {
                '1': 'തീരുമാനിച്ചിട്ടില്ല',
                '2': 'തീരുമാനം ആയി',
                '3': 'നടന്നില്ല',
                '4': 'നടന്നു'
            };
            
            const data = {
                meeting_level: parseInt(this.meetingForm.meeting_level),
                meeting_sublevel: this.getMeetingSublevelForSave(),
                meeting_name: this.meetingForm.meeting_name,
                meeting_date: this.meetingForm.meeting_date,
                meeting_time: this.meetingForm.meeting_time || null,
                meeting_mode: this.meetingForm.meeting_mode || null,
                status_level: parseInt(this.meetingForm.status_level),
                status: statusMap[this.meetingForm.status_level] || 'തീരുമാനിച്ചിട്ടില്ല',
                meeting_location: this.meetingForm.meeting_location || null,
                meeting_url: this.meetingForm.meeting_url || null,
            };

            // Special Meeting: send participant types
            if (this.isSpecialMeeting && this.meetingForm.special_meeting_participant_types && this.meetingForm.special_meeting_participant_types.length) {
                data.special_meeting_participant_types = this.meetingForm.special_meeting_participant_types;
            }

            // Add department_id if selected (non-special, non-self)
            if (!this.isSpecialMeeting && !this.isSelfMeeting && this.meetingForm.department_id) {
                data.department_id = parseInt(this.meetingForm.department_id);
                this.appendSelectedDepartmentFields(data);
            }

            if (this.isDepartmentMeeting) {
                data.department_meeting_participant_types = this.getSelectedDepartmentParticipantTypes();
            }

            data.wing = this.getMeetingWing();

            // Add location hierarchy based on user level
            const effectiveDistrictId = this.getEffectiveDistrictId();
            if (parseInt(this.meetingForm.meeting_level) == 2 && effectiveDistrictId) {
                data.district_id = effectiveDistrictId;
            }
            if (parseInt(this.meetingForm.meeting_level) == 3) {
                if (this.meetingForm.zone_id) {
                    data.zone_id = parseInt(this.meetingForm.zone_id);
                } else if (this.currentUser.zone_id) {
                    data.zone_id = this.currentUser.zone_id;
                }
            }

            UserService.authPostRequest('create-meeting', data).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status == 'success') {
                        $('#createMeetingModal').modal('hide');
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message || 'Meeting created successfully.';
                        this.$refs.alert_model.openModel();
                        // Always refresh Home tab since new meetings and actions start there
                        this.tabHome = true;
                        this.tabUpcoming = false;
                        this.tabOld = false;
                        this.getMeetings('Home');
                    } else {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message || 'Failed to create meeting.';
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        'Something went wrong. Please try again.';
                    this.$refs.alert_model.openModel();
                }
            );
        }
    },
};
</script>
<style scoped>
/* Upcoming / Old tabs: higher contrast and visibility */
.meetings-tabs-wrap .nav-tabs.capsuled.meetings-tabs {
    background: #e0e4ec;
    border: 1px solid #c5cad4;
    padding: 4px;
    border-radius: 10px;
}

.meetings-tabs-wrap .nav-tabs.capsuled .nav-item .nav-link {
    color: #374151;
    font-weight: 600;
    font-size: 14px;
    background: transparent;
}

.meetings-tabs-wrap .nav-tabs.capsuled .nav-item .nav-link:hover {
    color: #1a418c;
    background: rgba(26, 65, 140, 0.08);
}

.meetings-tabs-wrap .nav-tabs.capsuled .nav-item .nav-link.active {
    color: #1a418c;
    background: #ffffff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.meetings-tabs-wrap .nav-tabs.capsuled .nav-item .nav-link ion-icon {
    opacity: 1;
}

.list-title {
    font-size: 16px;
    color: black;
}

.item {
    margin-bottom: 0;
}

.report-btn {
    width: 100% !important;
}

.add-member-btn {
    font-size: 16px !important;
    font-weight: 800 !important;
}

.wallet-footer-user {
    min-height: 46px;
}

.text-only {
    font-size: 13px;
    font-weight: bold;
    color: black;
    /* margin-right: 5px; */
}


.chip-media {
    margin-left: 5px;
    width: 145px !important;
    padding-left: 25px !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.chip-icon {
    width: 50px !important;
}

.chip-label {
    padding: 0px 30px 0px 30px !important;
    font-size: 14px !important;
}

.bg-pink {
    background-color: #E6A6C7 !important;
}

.bg-pink-dark {
    background-color: #B85887 !important;
}


.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.menu-icon {
    font-size: 32px !important;
}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.back-color-primary {
    background: #1a418c !important;
}

.back-color-secondary {
    background: #666d79 !important;
}

.back-color-danger {
    background: #de6f56 !important;
}

.back-color-warning {
    background: #b19547 !important;
}

.back-color-red {
    background: #d55454 !important;
}

.back-color-violet {
    background: #072F5F !important;
}

.back-color-blue1 {
    background: #1a418c !important;
}

.back-color-blue2 {
    background: #1a418c !important;
}

.back-color-blue3 {
    background: #1a418c !important;
}

.back-color-blue4 {
    background: #1a418c !important;
}

.back-color-blue5 {
    background: #1a418c !important;
}

.back-color-blue6 {
    background: #1a418c !important;
}

.w-50 {
    width: 50px !important;
}

.goals .item {
    padding: 10px 10px;
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    margin-bottom: 10px;
}

.price-icon {
    /* margin-top: -1%; */
    font-size: 24px;
}

.chip-label[data-v-638c6bb6] {
    padding: 0px 5px 0px 5px !important;
    font-size: 14px !important;
}

.pad-5-left {
    padding-left: 5px;
}

.meeting-grid {
    display: grid;
    gap: 10px;
    max-width: 100%;
}

.meeting-card {
    background-color: #ffffff;
    border-radius: 8px;
    width: 100%;
    overflow: hidden;
}

.meeting-link {
    text-decoration: none;
    color: inherit;
    display: block;
    padding: 15px;
}

.in {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.meeting-details {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 10px;
}

.meeting-title {
    margin: 0 0 5px 0;
    font-size: 0.95rem;
    font-weight: 600;
    color: #333333;
    word-wrap: break-word;
}

.meeting-comment {
    margin: 0;
    font-size: 0.8rem;
    color: #666666;
    word-wrap: break-word;
}

.status-badge {
    color: #4CAF50;
    font-size: 1.5rem;
}

.title-line {
    border: 0;
    height: 1px;
    margin: 10px 0;
}

.detail-item {
    display: flex;
    align-items: flex-start;
    color: #666666;
    font-size: 0.9rem;
    padding: 8px;
    background-color: #f9f9f9;
    border-radius: 5px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e0e0e0;
}

.detail-icon {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    background-color: #f0f4f8;
    flex-shrink: 0;
}

.detail-icon ion-icon {
    font-size: 1.25rem;
    color: #011584;
}

.detail-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
}


.detail-label {
    font-size: 0.75rem;
    color: #888888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.detail-value {
    font-size: 0.9rem;
    color: #333333;
    font-weight: 500;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
}

.status-box {
    background-color: #cceac1;
    border-radius: 5px;
    padding: 5px 5px;
    display: inline-block;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.status-text {
    font-size: 0.8rem;
    color: #00796b;
    font-weight: 500;
}

.report-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 15px;
    margin-bottom: 10px;
    background-color: #f8f9fa;
    color: #000000;
    border: 1px solid #b9b9b9;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
}

.meeting-actions-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    margin-bottom: 12px;
    padding: 0 2px;
}

.action-card-link {
    text-decoration: none;
    display: block;
    width: 100%;
}

.action-card {
    width: 100%;
    border-radius: 10px;
    padding: 12px 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: none;
    position: relative;
    overflow: hidden;
}

.action-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.1);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.action-card:active::before {
    opacity: 1;
}

.action-card:active {
    transform: scale(0.98);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}

.action-card-content {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
    z-index: 1;
}

.action-card-icon-wrapper {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    backdrop-filter: blur(10px);
}

.action-card-icon-wrapper ion-icon {
    font-size: 24px;
    color: #ffffff;
}

.action-card-text {
    flex: 1;
    display: flex;
    align-items: center;
}

.action-card-title {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    line-height: 1.4;
    text-align: left;
}

.report-gradient {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #ffffff;
}

.report-gradient:hover {
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.create-gradient {
    background: linear-gradient(135deg, #1a418c 0%, #3f51b5 100%);
    color: #ffffff;
}

.create-gradient:hover {
    box-shadow: 0 4px 12px rgba(26, 65, 140, 0.4);
}

.meetings-gradient {
    background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
    color: #ffffff;
}

.meetings-gradient:hover {
    box-shadow: 0 4px 12px rgba(17, 153, 142, 0.4);
}

.assignments-gradient {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    color: #ffffff;
}

.assignments-gradient:hover {
    box-shadow: 0 4px 12px rgba(240, 147, 251, 0.4);
}

.assignment-card {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    border: 1px solid #e0e0e0;
}

.assignment-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.assignment-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
}

.assignment-title {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
    color: #333333;
    word-wrap: break-word;
    flex: 1;
    padding-right: 8px;
    line-height: 1.3;
}

.assignment-info {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.assignment-detail {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.8rem;
    color: #666666;
    flex-wrap: wrap;
    line-height: 1.4;
}

.assignment-detail.assignment-remarks-field {
    align-items: flex-start;
}

.assignment-detail ion-icon {
    font-size: 14px;
    color: #1a418c;
    flex-shrink: 0;
}

.assignment-label {
    font-weight: 500;
    color: #666666;
    min-width: 70px;
    font-size: 0.8rem;
}

.assignment-value {
    color: #333333;
    word-wrap: break-word;
    font-size: 0.8rem;
    flex: 1;
}

.assignment-remarks-field {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    margin-top: 2px;
}

.assignment-remarks-header {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
}

.assignment-remarks-input {
    width: 100%;
    padding: 5px 8px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 0.8rem;
    color: #333333;
    background-color: #ffffff;
    resize: vertical;
    min-height: 32px;
    max-height: 80px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, min-height 0.2s ease;
    font-family: inherit;
    line-height: 1.4;
    overflow-y: auto;
}

.assignment-remarks-input:hover {
    border-color: #1a418c;
}

.assignment-remarks-input:focus {
    outline: none;
    border-color: #1a418c;
    box-shadow: 0 0 0 2px rgba(26, 65, 140, 0.1);
}

.assignment-remarks-input:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
    opacity: 0.6;
}

.assignment-remarks-input::placeholder {
    color: #999999;
    font-style: italic;
}

.assignment-remarks-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.assignment-remark-item {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    padding: 6px 8px;
    background-color: #f5f7fa;
    border-radius: 6px;
    border: 1px solid #e0e0e0;
    font-size: 0.8rem;
    color: #333333;
}

.assignment-remark-text {
    flex: 1;
    word-wrap: break-word;
    line-height: 1.4;
}

.assignment-remark-remove {
    flex-shrink: 0;
    padding: 0;
    background: none;
    border: none;
    color: #999999;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.assignment-remark-remove:hover:not(:disabled) {
    color: #d32f2f;
}

.assignment-remark-remove ion-icon {
    font-size: 18px;
}

.assignment-remark-add {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.assignment-remark-new {
    min-height: 36px;
}

.assignment-remark-add-btn {
    align-self: flex-start;
    background-color: #1a418c;
    color: #fff;
    border: none;
    font-size: 0.75rem;
    padding: 4px 10px;
    border-radius: 4px;
}

.assignment-remark-add-btn:hover:not(:disabled) {
    background-color: #153a7a;
}

.assignment-status-select {
    flex: 1;
    padding: 4px 8px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 0.8rem;
    color: #333333;
    background-color: #ffffff;
    cursor: pointer;
    transition: border-color 0.2s ease;
    min-width: 100px;
    height: 28px;
}

.assignment-status-select:hover {
    border-color: #1a418c;
}

.assignment-status-select:focus {
    outline: none;
    border-color: #1a418c;
    box-shadow: 0 0 0 2px rgba(26, 65, 140, 0.1);
}

.assignment-status-select:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
    opacity: 0.6;
}

.assignment-status-select.status-assigned {
    color: #007bff;
    font-weight: 600;
}

.assignment-status-select.status-in-progress {
    color: #d4a012;
    font-weight: 600;
}

.assignment-status-select.status-on-hold {
    color: #e65100;
    font-weight: 600;
}

.assignment-status-select.status-completed {
    color: #28a745;
    font-weight: 600;
}

.assignment-actions {
    margin-top: 8px;
    padding-top: 12px;
    border-top: 1px solid #e0e0e0;
}

.view-meeting-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #1a418c;
    text-decoration: none;
    font-size: 0.9rem;
    font-weight: 500;
    transition: color 0.2s ease;
}

.view-meeting-link:hover {
    color: #0d2d5c;
    text-decoration: underline;
}

.view-meeting-link ion-icon {
    font-size: 18px;
}

.no-assignments-message {
    padding: 40px 20px;
    text-align: center;
}

.create-meeting-button {
    background-color: #1a418c;
    color: #ffffff;
    border: 1px solid #1a418c;
}

.create-meeting-button:hover {
    background-color: #153a7a;
    border-color: #153a7a;
}

.create-meeting-button:active {
    background-color: #0f2d5c;
    border-color: #0f2d5c;
}

.special-meeting-participants {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px 0;
}
.special-meeting-participants .participant-option {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-weight: 500;
}
.special-meeting-participants .participant-option input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.department-meeting-participants {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 4px 0;
}

.department-meeting-participants .participant-select-row {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.department-meeting-participants .participant-select-label {
    font-size: 0.9rem;
    font-weight: 500;
    color: #333333;
    margin-bottom: 0;
}

.department-meeting-participants .participant-group-block {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 4px;
    border-top: 1px solid #eef2f6;
}

.department-meeting-participants .secretariat-role-options {
    padding-left: 4px;
}

.participants-count-info {
    padding: 10px 12px;
    background-color: #e3f2fd;
    border-radius: 8px;
    border: 1px solid #90caf9;
    margin-bottom: 15px;
}

.participants-count-info .info-content-compact {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.participants-count-info .info-row-compact {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
}

.participants-count-info ion-icon {
    font-size: 18px;
    color: #1976d2;
    flex-shrink: 0;
}

.participants-count-info .info-label-compact {
    font-size: 0.85rem;
    color: #1976d2;
    font-weight: 500;
    white-space: nowrap;
}

.participants-count-info .info-text-compact {
    font-size: 0.85rem;
    color: #333333;
    font-weight: 600;
    flex: 1;
    word-wrap: break-word;
    line-height: 1.3;
}

.participants-count-info .count-value-compact {
    font-size: 0.9rem;
    color: #1976d2;
    font-weight: 700;
}

.meeting-name-display {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px;
    background-color: #f0f4f8;
    border-radius: 8px;
    border: 1px solid #cbd5e0;
    margin-bottom: 15px;
}

.meeting-name-display ion-icon {
    font-size: 24px;
    color: #1a418c;
}

.meeting-name-label {
    font-size: 0.9rem;
    color: #1a418c;
    font-weight: 500;
}

.meeting-name-value {
    font-size: 0.95rem;
    color: #333333;
    font-weight: 600;
    flex: 1;
    text-align: left;
}

/* Compact Meeting Card Styles */
.meeting-header-compact {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
}

.meeting-title-compact {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #333333;
    word-wrap: break-word;
    flex: 1;
    padding-right: 10px;
    line-height: 1.4;
}

.meeting-info-compact {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    width: 100%;
    font-size: 0.85rem;
    color: #666666;
}

.info-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.info-item ion-icon {
    font-size: 16px;
    color: #1a418c;
}

.info-separator {
    color: #999999;
    margin: 0 2px;
}

.meeting-location-compact {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    font-size: 0.85rem;
    color: #666666;
}

.meeting-location-compact ion-icon {
    font-size: 16px;
    color: #1a418c;
    flex-shrink: 0;
}

.meeting-location-compact span {
    word-wrap: break-word;
}

.today-meetings-section {
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
}

.section-title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 16px;
    padding: 0 4px;
}

.no-meetings-message {
    margin-top: 24px;
    padding: 20px;
    text-align: center;
}

.no-meetings-message p {
    font-size: 14px;
    color: #999999;
    margin: 0;
}

</style>